
import React, { createContext, useState, useContext } from 'react';

const LoaderContext = createContext();

export const LoaderProvider = ({ children }) => {
  const [loading, setLoading] = useState({});

  const showLoader = (componentId) => {
    setLoading((prev) => ({ ...prev, [componentId]: true }));

    setTimeout(() => {
      hideLoader(componentId);
    }, 3000);
  };

  const hideLoader = (componentId) => {
    setLoading((prev) => ({ ...prev, [componentId]: false }));
  };

  return (
    <LoaderContext.Provider value={{ loading, showLoader, hideLoader }}>
      {children}
    </LoaderContext.Provider>
  );
};

export const useLoader = (componentId) => {
  const context = useContext(LoaderContext);

  if (!context) {
    throw new Error('useLoader must be used within a LoaderProvider');
  }

  return {
    loading: context.loading[componentId] || false,
    showLoader: () => context.showLoader(componentId),
    hideLoader: () => context.hideLoader(componentId),
  };
};

